import React from 'react'
import { Link } from 'react-router-dom'

import Logo from '../../../common/assets/logo.js'

export default (props) => {
	const {
		count,
	} = props

	return (
		<div>
			<div className="header">
				<div className="u-width-wrap">
					<Logo />
				</div>
			</div>
			<div className="u-width-wrap">
				<h1 className="h1">Page Not Found</h1>
				<p className="p">{`The requested page does not exist. We will try to automatically redirect you to our home page in ${count} seconds.`}</p>
				<p className="p">Please go the 5FORTY home page by clicking the button below.</p>
				<Link className="a" to="/">5FORTY</Link>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/desktop/pages/notfound/default.js